import React from "react";
import VendorHeader from "../../../CustomComponents/Property/VendorHeader/VendorHeader";
import AgentSideBar from "../AgentSideBar/AgentSideBar";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { showSuccessToast } from "../../../assets/toastUtils";
import { useLocation } from "react-router-dom";
import { formatIndianCurrency, textDateFormatter } from "../../../utils/utils";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import Loader from "../../../CustomComponents/Loader/Loader";
import AddressAutocomplete from "../../../CustomComponents/CustomGooglePlaceAPi/AddressAutocomplete";
import SeeBookingSlider from "../../../CustomComponents/SeeBookingsSlider/SeeBookingsSlider";
import NoDataFound from "../../../CustomComponents/NoDataFound/NoDataFound";
import AgentHeader from "../AgentHeader/AgentHeader";
import AgentPackages from "../AgentPackages/AgentPackages";
import TourBookings from "../../../CustomComponents/TourBookings/TourBookings";
import styles from "../AgentPackages/AgentPackages.module.scss";

function AgentBooking() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const role = query.get("role");
  const [selectedButton, setSelectedButton] = useState("Hotels");
  const [loader, setLoader] = useState(false);
  const [allBookingsHotels, setAllBookingsHotels] = useState([]);
  const [allBookingsPackages, setAllBookingsPackages] = useState([]);
  const [allBookingsActivities, setAllBookingsActivities] = useState([]);
  const [allBookingsTransport, setAllBookingsTransport] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadResult, setUploadResult] = useState("");

  const handleFileChange = (event, type) => {
    const file = event.target.files[0];
    setSelectedFile(event.target.files[0]);
    handleSubmitCertificate(file, type);
  };

  const slug = window.location.pathname.split("/");
  // console.log(role ,"slug")

  const [activeTab, setActiveTab] = useState("Profile");

  useEffect(() => {
    if (role === "bookings") {
      setActiveTab("Bookings");
    } else {
      setActiveTab("Profile");
    }
  }, []);

  const [isSliderVisible, setIsSliderVisible] = useState(false);

  const handleCloseSlider = () => {
    setIsSliderVisible(false);
  };

  const handleChangeClick = async () => {
    setIsSliderVisible(true);
  };
  const [formData, setFormData] = useState({
    company_name: "",
    phone: "",
    email: "",
    gst_number: "",
    country: "",
    state: "",
    city: "",
    address: "",
    agent_category: "",
    pan: "",
    agent_category_discount: "",
    agent_discount_type: "",
    tan: "",
  });

  const [agentDetails, setAgentDetails] = useState(null);
  const [agentUpdateData, setAgentUpdateData] = useState(null);
  const userToken = localStorage.getItem("token");
  const agent_id = agentDetails?.AgentId;
  const account_id = agentDetails?.AccountId;
  const status = agentUpdateData?.data?.status;

  //fetch categories
  const [categoryDetail, setCategoryDetail] = useState(null);
  const [singleBookingData, setSingleBookingData] = useState(null);
  const [error, setError] = useState(null);

  // console.log("singleBookingData", singleBookingData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const navigate = useNavigate();

  const [addressData, setAddressData] = useState({
    country: "",
    state: "",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
    placeId: "",
  });

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  // console.log(userDetails);

  const [agentAccountDetails, setAgentAccountDetails] = useState({});
  // console.log(agentAccountDetails);

  const fetchAccountDetails = (id) => {
    setLoader(true);
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        key: "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      method: "GET",
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/v1/agents/credit-balance/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          setAgentAccountDetails(result.data);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => console.error("Error fetching single rate:", error));
  };

  useEffect(() => {
    if (userDetails?.AgentId) {
      fetchAccountDetails(userDetails?.AgentId);
    }
  }, [userDetails?.AgentId]);

  const handleAddressData = (data) => {
    // console.log(data, "data");
    setAddressData(data);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // console.log({ ...formData, ...addressData });

    const raw = JSON.stringify({ ...formData, ...addressData });

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/agent/update/${agent_id}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setAgentUpdateData(data);
        localStorage.setItem("isVerified", data?.data?.status || "false"); // Ensure proper saving
        showSuccessToast("Profile Saved Successfully");
        fetchAgentDetails();
        // navigate("/");
        // window.location.href = "/";
      })
      .catch((error) =>
        console.error(
          "There has been a problem with your fetch operation:",
          error
        )
      );
  };

  const profileFilter = (tab) => {
    setActiveTab(tab);
  };

  const fetchAgentDetails = () => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/user-profile`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setAgentDetails(data.data);

        localStorage.setItem("userDetails", JSON.stringify(data.data));
        localStorage.setItem("role", "agent");
        setAddressData({
          country: data.data.country || "",
          state: data.data.state || "",
          city: data.data.city || "",
          address: data.data.address || "",
          latitude: data.data.latitude || "",
          longitude: data.data.longitude || "",
          placeId: data.data.PlaceId || "",
        });
        setFormData({
          company_name: data.data.name || "",
          name: data.data.name || "",
          phone: data.data.phone || "",
          email: data.data.email || "",
          gst_number: data.data.gst_number || "",
          country: data.data.country || "",
          state: data.data.state || "",
          city: data.data.city || "",
          address: data.data.address || "",
          agent_category_discount: +data.data.agent_category_discount || "",
          agent_discount_type: data.data.agent_discount_type || "",
          agent_category: data.data.AgentCategoryName || "",
          pan: data.data.PAN_Number || "",
          tan: data.data.TAN_Number || "",
        });
        if (data.success) {
        }
      })
      .catch((error) => {
        console.error("Error fetching agent details:", error);
      });
  };

  // console.log(formData);

  useEffect(() => {
    const agentData = localStorage.getItem("role");
    // console.log(agentData);
    if (agentData === "agent") {
      fetchAgentDetails();
      fetchAgentsHotelsBookings();
      // fetchSidebarDetails();
    } else {
      fetchAgentDetails();
      // fetchAgentsBookings();
    }
    fetchAgentsHotelsBookings();
  }, [localStorage.getItem("role")]);

  const fetchCategoryDetail = () => {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/agents/category-list/${account_id}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); // Assuming the API returns JSON
      })
      .then((result) => {
        setCategoryDetail(result);
      })
      .catch((error) => {
        setError(error);
        console.error(
          "There was an error fetching the category details:",
          error
        );
      });
  };

  // const fetchAgentsBookings = () => {
  //   setLoader(true);
  //   const requestOptions = {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${userToken}`,
  //     },
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/v1/agents/bookings`,
  //     requestOptions
  //   )
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error("Network response was not ok");
  //       }
  //       return response.json(); // Assuming the API returns JSON
  //     })
  //     .then((result) => {
  //       if (result.success) {
  //         const groupByCategory = result?.data?.data?.reduce(
  //           (group, booking) => {
  //             const { tour_start } = booking;
  //             group[tour_start] = group[tour_start] ?? [];
  //             group[tour_start].push(booking);
  //             return group;
  //           },
  //           {}
  //         );
  //         setLoader(false);

  //         if (groupByCategory) {
  //           setAllBookings(groupByCategory);
  //         } else {
  //           setAllBookings([]);
  //         }
  //       }
  //       setLoader(false);
  //     })
  //     .catch((error) => {
  //       setLoader(false);
  //       setError(error);
  //       console.error(
  //         "There was an error fetching the category details:",
  //         error
  //       );
  //     });
  // };

  const fetchAgentsHotelsBookings = async () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      ` Bearer ${localStorage.getItem("token")}`
    );
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const raw = JSON.stringify({
      booking_type: "accommodation",
      account_type: "agent",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/bookings/fetch/list`,
        requestOptions
      );
      const data = await response.json();
      if (data.success) {
        setAllBookingsHotels(data.data);
        setLoader(false);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const fetchAgentsPackagesBookings = async () => {
    try {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
        Cookie: process.env.REACT_APP_COOKIE,
      };

      const body = JSON.stringify({
        booking_type: "package",
        account_type: "agent",
      });

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/bookings/fetch/list`,
        {
          method: "POST",
          headers: headers,
          body: body,
          redirect: "follow",
        }
      );

      const result = await response.json();
      if (result.success) {
        // const groupByCategory = result?.data?.reduce((group, booking) => {
        //   const { created_at: tour_start } = booking;
        //   group[tour_start] = group[tour_start] ?? [];
        //   group[tour_start].push(booking);
        //   return group;
        // }, {});
        setLoader(false);
        setAllBookingsPackages(result.data);
      }

      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching bookings:", error);
    }
  };

  const fetchAgentsActivitiesBookings = async () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      ` Bearer ${localStorage.getItem("token")}`
    );
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const raw = JSON.stringify({
      booking_type: "activity",
      account_type: "agent",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/bookings/fetch/list`,
        requestOptions
      );
      const data = await response.json();
      if (data.success) {
        setAllBookingsActivities(data.data);
        setLoader(false);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const fetchAgentsTransportBookings = async () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      ` Bearer ${localStorage.getItem("token")}`
    );
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const raw = JSON.stringify({
      booking_type: "transport",
      account_type: "agent",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/bookings/fetch/list`,
        requestOptions
      );
      const data = await response.json();
      if (data.success) {
        setAllBookingsTransport(data.data);
        setLoader(false);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  useEffect(() => {
    // setLoader(true); // Start loading before fetching

    switch (selectedButton) {
      case "Hotels":
        fetchAgentsHotelsBookings();
        break;
      case "Packages":
        fetchAgentsPackagesBookings();
        break;
      case "Activities":
        fetchAgentsActivitiesBookings();
        break;
      case "Transport":
        fetchAgentsTransportBookings();
        break;
      default:
        fetchAgentsHotelsBookings();
        setLoader(false);
        break;
    }
  }, [selectedButton]); // Dependency array ensures it runs when `selectedButton` changes

  // console.log(allBookings);

  const handleSubmitCertificate = (file, type) => {
    if (!file) {
      alert("Please select a file first!");
      return;
    }

    const formData = new FormData();
    formData.append("pdf", file);
    formData.append("collection", type);

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      body: formData,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/v1/agents/agent-doc-upload/${agent_id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        if (result.success) {
          setUploadResult(result);
          fetchAgentDetails();
          toast.success("File uploaded successfully");
        } else {
          toast.error(
            result.message ? result.message : "Error uploading file."
          );
        }
      })
      .catch((error) => {
        console.error(error);
        setUploadResult("Error uploading file.");
      });
  };

  // const fetchSidebarDetails = (bookingId) => {
  //   const myHeaders = new Headers();
  //   myHeaders.append("Accept", "application/json");
  //   myHeaders.append("key", process.env.REACT_APP_API_KEY);
  //   myHeaders.append(
  //     "Authorization",
  //     "Bearer " + localStorage.getItem("token")
  //   );
  //   const requestOptions = {
  //     method: "GET",
  //     headers: myHeaders,
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/v1/agents/single-booking/${bookingId}`,
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       if (result.success) {
  //         handleChangeClick();
  //         setSingleBookingData(result?.data);
  //       }
  //     })
  //     .catch((error) => console.error(error));
  // };

  const fetchSidebarDetails = async (bookingId) => {
    try {
      const myHeaders = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
        Cookie: process.env.REACT_APP_COOKIE,
      };

      const body = JSON.stringify({
        booking_type: "package",
      });

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/bookings/fetch/single/${bookingId}`,
        {
          method: "POST",
          headers: myHeaders,
          body: body,
          redirect: "follow",
        }
      );
      const result = await response.json();
      if (result.success) {
        handleChangeClick();
        setSingleBookingData(result?.data);
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    }
  };

  const fetchSidebarTourDetails = async (packageId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/bookings/fetch/single/${packageId}`;
    // const headers = new Headers();
    // headers.append("Accept", "application/json");

    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${userToken}`,
      Cookie: process.env.REACT_APP_COOKIE,
    };

    const body = JSON.stringify({
      booking_type: "package",
    });

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: body,
      redirect: "follow",
    };

    try {
      const response = await fetch(url, requestOptions);
      const result = await response.json();
      handleChangeClick();
      setSingleBookingData(result?.data);
      return result;
    } catch (error) {
      console.error("Error fetching booking data:", error);
      throw error; // Re-throw the error if needed
    }
  };

  const panImageData = agentDetails?.imageUrl?.find(
    (image) => image.collection === "PAN"
  );

  const gstImageData = agentDetails?.imageUrl?.find(
    (image) => image.collection === "gst_number"
  );

  const deleteImageHandler = async (mediaId) => {
    // console.log(mediaId);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("key", process.env.REACT_APP_API_KEY);
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );

    const raw = JSON.stringify({ mediaId });

    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_APP_URL}/api/v1/agents/delete-image`,
        requestOptions
      );
      const result = await response.json();

      if (result.success) {
        toast.success("Image deleted successfully");
        fetchAgentDetails();
      } else {
        toast.error(result.message ? result.message : "Error deleting image.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const dummyBookings = [
    {
      id: 88,
      uuid: "e57858fe-a56e-4ad7-b8a8-1aaf9c2b1a97",
      name: null,
      leadId: null,
      quotationId: null,
      customerId: 10,
      agentId: null,
      customerDetails: {
        id: 10,
        name: "sad",
        email: "sfdaskjh@sad.com",
        phone: "9820498203",
        city: "Dubai",
        state: "Uttar Pradesh",
        address: "Dubai, Uttar Pradesh 209867, India",
        country: "India",
        zipcode: "90803",
      },
      bookingType: "accommodation",
      bookingNo: 5831026709,
      total: 3750,
      tax_details: [
        {
          rate: 12,
          amount: 450,
        },
      ],
      grandTotal: 4200,
      status: "cancelled",
      dueAmount: 4200,
      paidAmount: 0,
      scheduledAmount: 0,
      createdAt: "2024-12-27",
    },
    {
      id: 89,
      uuid: "b1b16c88-63a3-4619-8f54-18016d934e75",
      name: null,
      leadId: null,
      quotationId: null,
      customerId: 10,
      agentId: null,
      customerDetails: {
        id: 10,
        name: "sad",
        email: "sfdaskjh@sad.com",
        phone: "9820498203",
        city: "Dubai",
        state: "Uttar Pradesh",
        address: "Dubai, Uttar Pradesh 209867, India",
        country: "India",
        zipcode: "90803",
      },
      bookingType: "accommodation",
      bookingNo: 6377700826,
      total: 3750,
      tax_details: [
        {
          rate: 12,
          amount: 450,
        },
      ],
      grandTotal: 4200,
      status: "cancelled",
      dueAmount: 4200,
      paidAmount: 0,
      scheduledAmount: 0,
      createdAt: "2024-12-27",
    },
    {
      id: 90,
      uuid: "be2000e1-0fe7-4fef-8fe9-4b9594946e31",
      name: null,
      leadId: null,
      quotationId: null,
      customerId: 10,
      agentId: null,
      customerDetails: {
        id: 10,
        name: "sad",
        email: "sfdaskjh@sad.com",
        phone: "9820498203",
        city: "Dubai",
        state: "Uttar Pradesh",
        address: "Dubai, Uttar Pradesh 209867, India",
        country: "India",
        zipcode: "90803",
      },
      bookingType: "accommodation",
      bookingNo: 4287060191,
      total: 3750,
      tax_details: [
        {
          rate: 12,
          amount: 450,
        },
      ],
      grandTotal: 4200,
      status: "confirmed",
      dueAmount: 4200,
      paidAmount: 0,
      scheduledAmount: 0,
      createdAt: "2024-12-27",
    },
  ];

  const getSelectedBookings = () => {
    switch (selectedButton) {
      case "Hotels":
        return allBookingsHotels;
      case "Packages":
        return allBookingsPackages;
      case "Activities":
        return allBookingsActivities;
      case "Transport":
        return allBookingsTransport;
      default:
        return [];
    }
  };

  const allBookingsCount = getSelectedBookings();

  const buttonOptions = ["Hotels", "Packages", "Activities", "Transport"];
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div id="Listingholidays">
        {/* <PageMetaData
        title="Mountain Mysteries"
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      /> */}

        <div className="sidebar_main_div new_sidebar_main_div">
          <AgentSideBar />

          <div className="agent-info-container">
            <AgentHeader showSelectProperty={true} vendorProperty={false} />
            <section className="w-full mt-20">
              <div className={styles.agent_bookings_section}>
                <div className="flex justify_content_between">
                  <div>
                    <h4>Bookings</h4>
                  </div>
                  <div className={styles.dropdownButtonFilter}>
                    <button onClick={() => setIsOpen(!isOpen)}>
                      {selectedButton}{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="15"
                        viewBox="0 0 14 15"
                        fill="none"
                        style={{
                          transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                        }}
                      >
                        <mask
                          id="mask0_6855_8756"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="14"
                          height="15"
                        >
                          <rect
                            y="14.5"
                            width="14"
                            height="14"
                            transform="rotate(-90 0 14.5)"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_6855_8756)">
                          <path
                            d="M7.0008 9.14202L11.3949 4.74791C11.5108 4.63202 11.6472 4.57554 11.8043 4.57845C11.9614 4.58147 12.0979 4.64092 12.2138 4.75681C12.3296 4.87279 12.3876 5.00929 12.3876 5.16631C12.3876 5.32332 12.3296 5.45982 12.2138 5.57581L7.74791 10.0506C7.64242 10.156 7.52425 10.2342 7.39338 10.2851C7.26252 10.3359 7.13166 10.3613 7.0008 10.3613C6.86994 10.3613 6.73908 10.3359 6.60822 10.2851C6.47736 10.2342 6.35918 10.156 6.2537 10.0506L1.7788 5.57581C1.66291 5.45982 1.60648 5.32181 1.60949 5.16179C1.6125 5.00176 1.67195 4.8638 1.78784 4.74791C1.90373 4.63202 2.04023 4.57408 2.19734 4.57408C2.35436 4.57408 2.49081 4.63202 2.6067 4.74791L7.0008 9.14202Z"
                            fill="white"
                          />
                        </g>
                      </svg>
                    </button>

                    {isOpen && (
                      <ul className={styles.dropdownButtonFilterChild}>
                        {buttonOptions.map((option) => (
                          <li
                            key={option}
                            className=""
                            onClick={() => {
                              setSelectedButton(option);
                              setIsOpen(false);
                            }}
                          >
                            {option}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

                <div className={styles.total_bookings_sec}>
                  <div className={styles.total_bookings_sec_item}>
                    Total Bookings
                    <span>{allBookingsCount?.length}</span>
                  </div>
                  <div className={styles.total_bookings_sec_item}>
                    Confirmed
                    <span>
                      {
                        allBookingsCount?.filter(
                          (item) => item.status === "confirm"
                        ).length
                      }
                    </span>
                  </div>
                  <div className={styles.total_bookings_sec_item}>
                    Hold
                    <span>
                      {
                        allBookingsCount?.filter(
                          (item) => item.status === "hold"
                        ).length
                      }
                    </span>
                  </div>
                  <div className={styles.total_bookings_sec_item}>
                    Cancelled
                    <span>
                      {
                        allBookingsCount?.filter(
                          (item) => item.status === "cancelled"
                        ).length
                      }
                    </span>
                  </div>
                </div>
              </div>

              {selectedButton === "Hotels" ? (
                <div id="common_background_profile m_20 mt_10">
                  <div className="common_background mt-10">
                    <div className="profile_content Bookings">
                      {allBookingsHotels?.length > 0 ? (
                        <>
                          <div className={styles.tableContainer}>
                            <div
                              className="overflow_x_scroll_y_hidden"
                              id="csv_download"
                            >
                              <table
                                className="mt-10 customTable"
                                id="customTable"
                              >
                                <thead>
                                  <tr>
                                    <th>Booking Number</th>
                                    <th>Email</th>
                                    <th>Phone No.</th>
                                    <th>Grand Total</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {allBookingsHotels.map((data, index) => (
                                    <tr key={index}>
                                      <td>
                                        <span
                                          onClick={() =>
                                            fetchSidebarDetails(data?.id)
                                          }
                                          className={styles.bookingNumber}
                                          style={{
                                            background: "transparent",
                                            border: "none",
                                            color: "#3968ED",
                                            padding: "0",
                                          }}
                                        >
                                          # {data?.bookingNo}
                                        </span>
                                        <p>{data?.customerDetails?.name}</p>
                                      </td>
                                      <td>
                                        {data?.customerDetails?.email || "N/A"}
                                      </td>
                                      <td>
                                        {data?.customerDetails?.phone || "N/A"}
                                      </td>
                                      <td>₹{data?.grandTotal}</td>
                                      <td>
                                        <span
                                          className={`${
                                            styles.tableStatus
                                          } text-capitalize ${
                                            data.status === "confirmed"
                                              ? styles.confirm
                                              : styles.cancelled
                                          }`}
                                        >
                                          {data?.status}
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>

                            {isSliderVisible && singleBookingData && (
                              <SeeBookingSlider
                                singleBookingData={singleBookingData}
                                onClose={handleCloseSlider}
                                setIsSliderVisible={setIsSliderVisible}
                              />
                            )}
                          </div>
                        </>
                      ) : (
                        <NoDataFound />
                      )}
                    </div>
                  </div>
                </div>
              ) : selectedButton === "Packages" ? (
                // <AgentPackages
                //   selectedButton={selectedButton}
                //   setSelectedButton={setSelectedButton}
                // />
                <>
                  {loader ? (
                    <Loader size="4em" color="#016932" />
                  ) : allBookingsPackages.length > 0 ? (
                    <>
                      <div className={styles.tableContainer}>
                        <div
                          className="overflow_x_scroll_y_hidden "
                          id="csv_download"
                        >
                          <table className="mt-10 customTable" id="customTable">
                            <thead>
                              <tr>
                                <th>Booking Number</th>
                                <th>Email</th>
                                <th>Tour Name</th>
                                <th>Phone No.</th>
                                <th>Grand Total</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allBookingsPackages &&
                                allBookingsPackages?.length > 0 &&
                                allBookingsPackages?.map((data, index) => (
                                  <tr key={index}>
                                    <td>
                                      {" "}
                                      <span
                                        onClick={() =>
                                          fetchSidebarTourDetails(data?.id)
                                        }
                                        className={styles.bookingNumber}
                                        style={{
                                          background: "transparent",
                                          border: "none",
                                          color: "#3968ED",
                                          padding: "0",
                                        }}
                                      >
                                        # {data?.bookingNo}
                                      </span>{" "}
                                      <br />
                                    </td>
                                    <td>
                                      {data?.customerDetails?.email
                                        ? data?.customerDetails?.email
                                        : "N/A"}
                                    </td>
                                    <td>{data?.name ? data?.name : "N/A"}</td>
                                    <td>
                                      {" "}
                                      {data?.customerDetails?.phone
                                        ? data?.customerDetails?.phone
                                        : "N/A"}
                                    </td>
                                    <td>{data?.grandTotal}</td>
                                    <td>
                                      {" "}
                                      <span
                                        className={`${
                                          styles.tableStatus
                                        } text-capitalize ${
                                          data.status === "confirmed"
                                            ? styles.confirm
                                            : styles.cancelled
                                        }`}
                                      >
                                        {" "}
                                        {data?.status}
                                      </span>{" "}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>

                        {/* Booking Content End */}
                      </div>

                      {isSliderVisible && singleBookingData && (
                        <TourBookings
                          singleBookingData={singleBookingData}
                          onClose={handleCloseSlider}
                          setIsSliderVisible={setIsSliderVisible}
                        />
                      )}
                    </>
                  ) : (
                    <NoDataFound />
                  )}
                </>
              ) : selectedButton === "Activities" ? (
                <>
                  {loader ? (
                    <Loader size="4em" color="#016932" />
                  ) : allBookingsActivities.length > 0 ? (
                    <>
                      <div className={styles.tableContainer}>
                        <div
                          className="overflow_x_scroll_y_hidden "
                          id="csv_download"
                        >
                          <table className="mt-10 customTable" id="customTable">
                            <thead>
                              <tr>
                                <th>Booking Number</th>
                                <th>Email</th>
                                <th>Tour Name</th>
                                <th>Phone No.</th>
                                <th>Grand Total</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allBookingsActivities &&
                                allBookingsActivities?.length > 0 &&
                                allBookingsActivities?.map((data, index) => (
                                  <tr key={index}>
                                    <td>
                                      {" "}
                                      <span
                                        onClick={() =>
                                          fetchSidebarTourDetails(data?.id)
                                        }
                                        className={styles.bookingNumber}
                                        style={{
                                          background: "transparent",
                                          border: "none",
                                          color: "#3968ED",
                                          padding: "0",
                                        }}
                                      >
                                        # {data?.bookingNo}
                                      </span>{" "}
                                      <br />
                                    </td>
                                    <td>
                                      {data?.customerDetails?.email
                                        ? data?.customerDetails?.email
                                        : "N/A"}
                                    </td>
                                    <td>{data?.name ? data?.name : "N/A"}</td>
                                    <td>
                                      {" "}
                                      {data?.customerDetails?.phone
                                        ? data?.customerDetails?.phone
                                        : "N/A"}
                                    </td>
                                    <td>{data?.grandTotal}</td>
                                    <td>
                                      {" "}
                                      <span
                                        className={`${
                                          styles.tableStatus
                                        } text-capitalize ${
                                          data.status === "confirmed"
                                            ? styles.confirm
                                            : styles.cancelled
                                        }`}
                                      >
                                        {" "}
                                        {data?.status}
                                      </span>{" "}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>

                        {/* Booking Content End */}
                      </div>

                      {isSliderVisible && singleBookingData && (
                        <TourBookings
                          singleBookingData={singleBookingData}
                          onClose={handleCloseSlider}
                          setIsSliderVisible={setIsSliderVisible}
                        />
                      )}
                    </>
                  ) : (
                    <NoDataFound />
                  )}
                </>
              ) : selectedButton === "Transport" ? (
                <>
                  {loader ? (
                    <Loader size="4em" color="#016932" />
                  ) : allBookingsTransport.length > 0 ? (
                    <>
                      <div className={styles.tableContainer}>
                        <div
                          className="overflow_x_scroll_y_hidden "
                          id="csv_download"
                        >
                          <table className="mt-10 customTable" id="customTable">
                            <thead>
                              <tr>
                                <th>Booking Number</th>
                                <th>Email</th>
                                <th>Tour Name</th>
                                <th>Phone No.</th>
                                <th>Grand Total</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allBookingsTransport &&
                                allBookingsTransport?.length > 0 &&
                                allBookingsTransport?.map((data, index) => (
                                  <tr key={index}>
                                    <td>
                                      {" "}
                                      <span
                                        onClick={() =>
                                          fetchSidebarTourDetails(data?.id)
                                        }
                                        className={styles.bookingNumber}
                                        style={{
                                          background: "transparent",
                                          border: "none",
                                          color: "#3968ED",
                                          padding: "0",
                                        }}
                                      >
                                        # {data?.bookingNo}
                                      </span>{" "}
                                      <br />
                                    </td>
                                    <td>
                                      {data?.customerDetails?.email
                                        ? data?.customerDetails?.email
                                        : "N/A"}
                                    </td>
                                    <td>{data?.name ? data?.name : "N/A"}</td>
                                    <td>
                                      {" "}
                                      {data?.customerDetails?.phone
                                        ? data?.customerDetails?.phone
                                        : "N/A"}
                                    </td>
                                    <td>{data?.grandTotal}</td>
                                    <td>
                                      {" "}
                                      <span
                                        className={`${
                                          styles.tableStatus
                                        } text-capitalize ${
                                          data.status === "confirmed"
                                            ? styles.confirm
                                            : styles.cancelled
                                        }`}
                                      >
                                        {" "}
                                        {data?.status}
                                      </span>{" "}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>

                        {/* Booking Content End */}
                      </div>

                      {isSliderVisible && singleBookingData && (
                        <TourBookings
                          singleBookingData={singleBookingData}
                          onClose={handleCloseSlider}
                          setIsSliderVisible={setIsSliderVisible}
                        />
                      )}
                    </>
                  ) : (
                    <NoDataFound />
                  )}
                </>
              ) : null}
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default AgentBooking;

// {loader ? (
//   <Loader size={"4em"} color="#016932" />
// ) : allBookings.length > 0 ? (
//   <div>
//     {allBookings.map((item) => (
//       <div key={item}>
//         <h6 className="mt-10">{textDateFormatter(item)}</h6>
//         {allBookings[item]?.length > 0 &&
//           allBookings[item].map((booking) => (
//             <div
//               key={booking?.uuid}
//               className="booking_details"
//             >
//               <div className="flex  flex_gap_15 align_items_center">
//                 <div className="vector_img">
//                   <svg
//                     width="20"
//                     height="18"
//                     viewBox="0 0 20 18"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M15 16H17V8H11V16H13V10H15V16ZM1 16V1C1 0.734784 1.10536 0.48043 1.29289 0.292893C1.48043 0.105357 1.73478 0 2 0H16C16.2652 0 16.5196 0.105357 16.7071 0.292893C16.8946 0.48043 17 0.734784 17 1V6H19V16H20V18H0V16H1ZM5 8V10H7V8H5ZM5 12V14H7V12H5ZM5 4V6H7V4H5Z"
//                       fill="#888888"
//                     />
//                   </svg>
//                 </div>
//                 <div>
//                   <p>{booking?.property?.name}</p>
//                   <button
//                     className="view_btn"
//                     onClick={() =>
//                       fetchSidebarDetails(
//                         booking?.uuid
//                       )
//                     }
//                   >
//                     See Details
//                   </button>
//                 </div>
//               </div>
//               <div className="agent">
//                 <div>
//                   <small>Email</small>
//                   <p>
//                     {formatIndianCurrency(
//                       booking?.customerDetails?.email
//                     )}
//                   </p>
//                 </div>
//                 <div>
//                   <small>Phone No.</small>
//                   <p>
//                     {formatIndianCurrency(
//                       booking?.customerDetails?.phone
//                     )}
//                   </p>
//                 </div>
//                 <div>
//                   <small>Total Amount</small>
//                   <p>
//                     {formatIndianCurrency(
//                       booking?.grandTotal
//                     )}
//                   </p>
//                 </div>
//                 {/* <div>
//                   <small>Check-In</small>
//                   <p>
//                     {textDateFormatter(booking?.tour_start)}
//                   </p>
//                 </div>
//                 <div>
//                   <small>Check-Out</small>
//                   <p>
//                     {textDateFormatter(booking?.tour_end)}
//                   </p>
//                 </div> */}
//                 <div>
//                   <span className="change_btn text-capitalize">
//                     {booking?.booking_status}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           ))}
//       </div>
//     ))}
//     {isSliderVisible && singleBookingData && (
//       <SeeBookingSlider
//         singleBookingData={singleBookingData}
//         onClose={handleCloseSlider}
//         setIsSliderVisible={setIsSliderVisible}
//       />
//     )}
//   </div>
// ) : (
//   <NoDataFound />
// )}

// {dummyBookings.map((booking) => (
//   <div key={booking?.id} className="booking_details">
//     <div className="flex  flex_gap_15 align_items_center">
//       <div className="vector_img">
//         <svg
//           width="20"
//           height="18"
//           viewBox="0 0 20 18"
//           fill="none"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <path
//             d="M15 16H17V8H11V16H13V10H15V16ZM1 16V1C1 0.734784 1.10536 0.48043 1.29289 0.292893C1.48043 0.105357 1.73478 0 2 0H16C16.2652 0 16.5196 0.105357 16.7071 0.292893C16.8946 0.48043 17 0.734784 17 1V6H19V16H20V18H0V16H1ZM5 8V10H7V8H5ZM5 12V14H7V12H5ZM5 4V6H7V4H5Z"
//             fill="#888888"
//           />
//         </svg>
//       </div>
//       <div>
//         {/* <p>{booking?.property?.name}</p> */}
//         <button
//           className="view_btn"
//           // onClick={() => setIsSliderVisible(true)}

//           onClick={() => fetchSidebarDetails(booking?.id)}
//         >
//           See Details
//         </button>
//       </div>
//     </div>
//     {/* <div className="agent"> */}
//     <div>
//       <small>Booking No.</small>
//       <p>{booking?.bookingNo}</p>
//     </div>
//     <div>
//       <small>Email</small>
//       <p>{booking?.customerDetails?.email}</p>
//     </div>
//     <div>
//       <small>Phone No.</small>
//       <p>
//         {booking?.customerDetails?.phone
//           ? booking?.customerDetails?.phone
//           : "N/A"}
//       </p>
//     </div>
//     <div>
//       <small>Grand Total</small>
//       <p>{formatIndianCurrency(booking?.grandTotal)}</p>
//     </div>
//     <div>
//       <small>Status</small>
//       <p>{booking?.status}</p>
//     </div>
//     {/* </div> */}

//     {/* {isSliderVisible && (
//   <SeeBookingSlider
//     singleBookingData={booking}
//     onClose={handleCloseSlider}
//     setIsSliderVisible={setIsSliderVisible}
//   />
// )} */}

//     {isSliderVisible && singleBookingData && (
//       <SeeBookingSlider
//         singleBookingData={singleBookingData}
//         onClose={handleCloseSlider}
//         setIsSliderVisible={setIsSliderVisible}
//       />
//     )}
//   </div>
// ))}

// try {
//   const headers = {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//     Authorization:
//       `Bearer ${userToken}`,
//     Cookie: process.env.REACT_APP_COOKIE,
//   };

//   const body = JSON.stringify({
//     booking_type: "accommodation",
//     account_type: "agent",
//   });

//   const response = await fetch(
//     `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/bookings/fetch/list`,
//     {
//       method: "POST",
//       headers: headers,
//       body: body,
//       redirect: "follow",
//     }
//   );

//   const result = await response.json();
//   setAllBookings(result.data);
//   setLoader(false);
// } catch (error) {
//   console.error("Error fetching bookings:", error);
//   setLoader(false);
// }
